import { Square, PieceSymbol } from "chess.js";

export type AnalysisMode = "analysis" | "edit";

export interface CastlingRights {
  K: boolean;
  Q: boolean;
  k: boolean;
  q: boolean;
}

export interface PromotionMove {
  from: Square;
  to: Square;
}

export interface LastMove {
  from: Square;
  to: Square;
  promotion?: PieceSymbol;
}

export const STARTING_FEN = "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1";

export const WHITE_SPARE_PIECES = ["wK", "wQ", "wR", "wB", "wN", "wP"];
export const BLACK_SPARE_PIECES = ["bK", "bQ", "bR", "bB", "bN", "bP"];
